import { createDynamicSlice } from ".";
import { fetchDeletedAuditsThunk } from "../thunks/deletedAuditsThunk";

export const deletedAuditsSlice = createDynamicSlice({
  name: "deletedAudits",
  thunk: fetchDeletedAuditsThunk,
  listMode: true,
  resetActionName: "resetDeletedAudits",
});

export const deletedAuditsReducer = deletedAuditsSlice.reducer;
export const { resetDeletedAudits } = deletedAuditsSlice.actions;
